module.exports = __webpack_public_path__ + "img/logo.cb5c0799.svg";